import React, { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import _VoicemailModal from "routes/voicemail/components/VoicemailModal";
import VoicemailService from "services/Voicemails";
import {
  invalidateVoicemailsQuery,
  useVoicemailTable,
} from "hooks/useVoicemailTable";

export const VOICEMAILS_TABLE_CONSTANTS = {
  tableName: "voicemails",
  queryKey: "voicemails",
  className: "Voicemail",
  exportTableName: null,
  header: "Voicemails",
  headerIcon: "file audio",
};

const VoicemailModal = withRoleCheck(_VoicemailModal, [
  ACL_RELATIONSHIPS.voicemail.create,
]);

const VoicemailTableV3 = () => {
  const { columns } = useVoicemailTable();

  const fetchVoicemails = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await VoicemailService.getVoicemails(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching voicemails:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={VOICEMAILS_TABLE_CONSTANTS.headerIcon}
      header={VOICEMAILS_TABLE_CONSTANTS.header}
      queryKey={VOICEMAILS_TABLE_CONSTANTS.queryKey}
      className={VOICEMAILS_TABLE_CONSTANTS.className}
      tableName={VOICEMAILS_TABLE_CONSTANTS.tableName}
      createButton={<VoicemailModal onSuccess={invalidateVoicemailsQuery} />}
      fetchData={fetchVoicemails}
      invalidateData={invalidateVoicemailsQuery}
      enableSettings
    />
  );
};

export default VoicemailTableV3;
